import { ComponentType } from 'react'
import { useAsync } from 'react-async'
import axios from 'axios'

type CurrentVisitResponse = {
  location: {
    lat: number
    lng: number
    name: string
  }
  country: {
    code: string
  }
}

const getCurrentVisit = () => axios.get<CurrentVisitResponse>('current_visit')

export const useCurrentVisit = () => useAsync(getCurrentVisit)

const withCurrentVisit = <P extends object>(Component: ComponentType<P>) => (
  props: P
) => {
  const { data: currentVisit, isLoading } = useCurrentVisit()

  return (
    <Component
      {...props}
      currentVisit={currentVisit?.data}
      currentVisitLoading={isLoading}
    />
  )
}

export default withCurrentVisit
